<template>
  <v-container fluid name="nombreneLettres">
    <v-layout
      d-flex
      row
    >
      <v-flex
        md1
        offset-md0
        class="nec"
      >
        {{parsedNumber[0]}} millier{{parsedNumber[0]>1?'s':''}}
      </v-flex>
      <v-flex
        md1
        offset-md0
        class="nec"
      >
        {{parsedNumber[1]}} centaine{{parsedNumber[1]>1?'s':''}}
      </v-flex>
      <v-flex
        md1
        offset-md0
        class="nec"
      >
        {{parsedNumber[2]}} dizaine{{parsedNumber[2]>1?'s':''}}
      </v-flex>
      <v-flex
        md1
        offset-md0
        class="nec"
      >
        {{parsedNumber[3]}} unite{{parsedNumber[3]>1?'s':''}}
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>

  export default {
    name: "NombreEnChiffres",
    components: {
    },
    computed: {
      nombreEnChiffres: {
        get() {
            return this.en_lettre(this.parsedNumber);
        },
      },

    },
    props: {
      parsedNumber:Array,
    },
    data () {
      return {
        milliers:0,
        centaines:0,
        dizaines:0,
        unites:0,
      }
    },
    methods: {
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  .nec{
    text-align: center;
  }
</style>
